import { STATUSES_THAT_REMOVE_DO_NOT_FLAG } from '../constants';

export type ApplicationStatusChangeModalParams = {
  oldStatus: string;
  newStatus: string;
  formType?: string;
  adopterStatus?: string | null;
  doNotAdopt?: boolean;
  contentTarget: Record<string, string>;
  t: (key: string, params?: Record<string, string>) => string;
  shelterProfile?: {
    application_approved_email_status?: boolean;
    application_canceled_email_status?: boolean;
    application_declined_email_status?: boolean;
  };
};

export type ApplicationStatusChangeModalResult = {
  content: string;
  secondContent: string;
  confirmWordKey?: string;
  isDeclinedApplication: boolean;
};

const CONFIRM_WORD_CLEAR_KEY = 'people.individualPage.profileInfo.actionsOptions.confirmWordClear';

export default function getApplicationStatusChangeModalProps(
  params: ApplicationStatusChangeModalParams
): ApplicationStatusChangeModalResult {
  const { oldStatus, newStatus, formType, adopterStatus, doNotAdopt, contentTarget, t, shelterProfile } = params;
  const oldStatusLower = (oldStatus || '').toLowerCase();
  const newStatusLower = (newStatus || '').toLowerCase();
  const formTypeLower = (formType || '').toLowerCase();

  const isChangingToDoNotAdopt = newStatusLower === 'do not adopt' && formTypeLower === 'adoption';
  const hasDoNotAdoptStatus = oldStatusLower === 'do not adopt' || doNotAdopt === true;
  const isChangingFromDoNotAdoptToPendingApprovedOrSubmitted =
    hasDoNotAdoptStatus && formTypeLower === 'adoption' && STATUSES_THAT_REMOVE_DO_NOT_FLAG.includes(newStatusLower);

  const action = contentTarget[newStatus] || contentTarget[newStatusLower];
  // prettier-ignore
  const content = isChangingToDoNotAdopt ? 'adoption.modal.application.confirmChangeToDoNotAdopt'
    : isChangingFromDoNotAdoptToPendingApprovedOrSubmitted ? t('adoption.modal.application.confirmChangeFromDoNotAdopt', { action })
    : t('adoption.modal.areYouSure', { action });

  let secondContent = '';
  if (
    !isChangingToDoNotAdopt &&
    !isChangingFromDoNotAdoptToPendingApprovedOrSubmitted &&
    formType === 'adoption' &&
    ((newStatusLower === 'approved' && shelterProfile?.application_approved_email_status !== false) ||
      (newStatusLower === 'canceled' && shelterProfile?.application_canceled_email_status !== false) ||
      (newStatusLower === 'declined' && shelterProfile?.application_declined_email_status !== false))
  ) {
    secondContent = t('adoption.modal.application.emailSent', { status: newStatus });
  }

  const confirmWordKey = isChangingFromDoNotAdoptToPendingApprovedOrSubmitted ? CONFIRM_WORD_CLEAR_KEY : undefined;

  const isDeclinedApplication =
    newStatusLower === 'declined' &&
    formType === 'adoption' &&
    shelterProfile?.application_declined_email_status !== false;

  return { content, secondContent, confirmWordKey, isDeclinedApplication };
}
